import { attach } from 'effector';

import { api } from '@shared/api/api';

const signUpFx = attach({ effect: api.auth.signupInit });
const resendEmailCodeFx = attach({ effect: api.auth.resendEmailCode });

export { signUpFx, resendEmailCodeFx };
